import { Notification } from '@components/notification';
import { Box, Grid } from '@mui/material';
import { useAtomValue } from 'jotai';
import { PropsWithChildren, useEffect, useState } from 'react';
import {
  addNotification,
  createAsyncNotification,
  notificationsAtom,
  removeAllNotifications,
  removeNotification,
} from './notificationsAtoms';

const notificationsApi = {
  addNotification,
  removeNotification,
  removeAllNotifications,
  createAsyncNotification,
};

export const useNotifications = () => notificationsApi;

export const NotificationsProvider = ({ children }: PropsWithChildren) => (
  <>
    {children}
    <NotificationStackContainer />
  </>
);

type RouteState = { error?: string };
const LIMIT = 10;

const NotificationStackContainer = ({ routeState }: { routeState?: RouteState }) => {
  const notifications = useAtomValue(notificationsAtom);
  const [fromRouteError, setFromRouteError] = useState(routeState?.error);

  const clearRouteStateError = () => {
    setFromRouteError(null);
    history.replaceState({ ...history.state, error: null }, '', '/');
  };

  useEffect(() => {
    if (routeState?.error) {
      setFromRouteError(routeState?.error);
      setTimeout(() => clearRouteStateError(), 3000);
    }
  }, [routeState]);

  return (
    <Box position="fixed" left={10} bottom={10} zIndex={10000}>
      <Grid container spacing={4} direction="column">
        {(notifications ?? []).slice(0, LIMIT).map(({ key, onClose, ...rest }) => (
          <Grid item key={key}>
            <Notification
              {...rest}
              onClose={(e) => {
                removeNotification(key);
                if (onClose) {
                  onClose(e);
                }
              }}
            />
          </Grid>
        ))}
        {fromRouteError && (
          <Notification text={fromRouteError} type="error" onClose={clearRouteStateError} />
        )}
      </Grid>
    </Box>
  );
};
